import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { GetDirectoryQueryResponse, GetDirectory400, GetDirectory404 } from "../types/GetDirectory";

export const getDirectoryQueryKey = () =>     [{url:`/v1/directory`}] as const;
      export function getDirectoryQueryOptions <TData = GetDirectoryQueryResponse, TError = GetDirectory400 | GetDirectory404>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getDirectoryQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/v1/directory`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @description Метод предназначен для запроса справочников аукционов https://confluence.poleinvest.ru/pages/viewpage.action?pageId=425486289

 * @link /v1/directory
 */

export function useGetDirectory <TData = GetDirectoryQueryResponse, TError = GetDirectory400 | GetDirectory404>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDirectoryQueryKey();

  const query = useQuery<TData, TError>({
    ...getDirectoryQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
